var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-xl" }, [
    _c("div", { staticClass: "header header-search-ticket-office" }, [
      _c("div", { staticClass: "row mb-5 mb-lg-0" }, [
        _c("div", { staticClass: "col-10 offset-1" }, [
          _c("form", { staticClass: "mt-5 form-search-ticket-office" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  ref: "filterCollapse",
                  staticClass: "collapse",
                  attrs: { id: "filterCollapse" },
                },
                [_vm._m(2)]
              ),
            ]),
            _vm._v(" "),
            _vm._m(3),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "h3" }, [
      _c("strong", [_vm._v("Wyszukiwarka")]),
      _vm._v(" kas i biletomatów\n          "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mb-4 mt-2 g-2" }, [
      _c("div", { staticClass: "col-12 col-lg-10" }, [
        _c(
          "div",
          {
            staticClass:
              "position-relative form-search-ticket-office-input-container",
          },
          [
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "searchTicketsInput",
                placeholder: "Podaj miasto",
                tabindex: "1",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-2 d-none d-lg-block" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-warning w-100 mb-3 w-md-25",
            attrs: { type: "submit", tabindex: "3" },
          },
          [_vm._v("Szukaj")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "flex-wrap justify-content-center d-flex flex-column flex-md-row",
      },
      [
        _c("div", { staticClass: "me-md-2 mb-3" }, [
          _c("input", {
            staticClass: "btn-check",
            attrs: {
              type: "checkbox",
              id: "searchTicketsFilter1",
              checked: "",
              autocomplete: "off",
              tabindex: "2",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "btn btn-light",
              attrs: { type: "label", for: "searchTicketsFilter1" },
            },
            [_vm._v("Kasy krajowe")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "me-md-2 mb-3" }, [
          _c("input", {
            staticClass: "btn-check",
            attrs: {
              type: "checkbox",
              id: "searchTicketsFilter2",
              checked: "",
              autocomplete: "off",
              tabindex: "2",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "btn btn-light",
              attrs: { type: "label", for: "searchTicketsFilter2" },
            },
            [_vm._v("Kasy międzynarodowe")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "me-md-2 mb-3" }, [
          _c("input", {
            staticClass: "btn-check",
            attrs: {
              type: "checkbox",
              id: "searchTicketsFilter3",
              checked: "",
              autocomplete: "off",
              tabindex: "2",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "btn btn-light",
              attrs: { type: "label", for: "searchTicketsFilter3" },
            },
            [_vm._v("Biletomaty")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "me-md-2 mb-3" }, [
          _c("input", {
            staticClass: "btn-check",
            attrs: {
              type: "checkbox",
              id: "searchTicketsFilter4",
              checked: "",
              autocomplete: "off",
              tabindex: "2",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "btn btn-light",
              attrs: { type: "label", for: "searchTicketsFilter4" },
            },
            [_vm._v("Płatność kartą")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "me-md-2 mb-3" }, [
          _c("input", {
            staticClass: "btn-check",
            attrs: {
              type: "checkbox",
              id: "searchTicketsFilter5",
              checked: "",
              autocomplete: "off",
              tabindex: "2",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "btn btn-light",
              attrs: { type: "label", for: "searchTicketsFilter5" },
            },
            [_vm._v("Obniżony blat")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "me-md-2 mb-3" }, [
          _c("input", {
            staticClass: "btn-check",
            attrs: {
              type: "checkbox",
              id: "searchTicketsFilter6",
              checked: "",
              autocomplete: "off",
              tabindex: "2",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "btn btn-light",
              attrs: { type: "label", for: "searchTicketsFilter6" },
            },
            [_vm._v("Pętla indukcyjna")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "me-md-2 mb-3" }, [
          _c("input", {
            staticClass: "btn-check",
            attrs: {
              type: "checkbox",
              id: "searchTicketsFilter7",
              checked: "",
              autocomplete: "off",
              tabindex: "2",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "btn btn-light",
              attrs: { type: "label", for: "searchTicketsFilter7" },
            },
            [
              _vm._v(
                "Biletomat dla osób z\n                    niepełnosprawnością"
              ),
            ]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "mobile-ctrl flex-column flex-lg row d-flex d-lg-none row-cols-1",
      },
      [
        _c("div", { staticClass: "col" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-light w-100 mb-3 w-md-25",
              attrs: {
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#filterCollapse",
                "aria-expanded": "false",
                "aria-controls": "filterCollapse",
              },
            },
            [
              _c("i", { staticClass: "bi bi-funnel-fill" }),
              _vm._v(" Filtruj\n              "),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col mt-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning w-100 mb-3 w-md-25",
              attrs: { type: "submit" },
            },
            [_vm._v("Szukaj")]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }